/* Disclaimer for layouts that use the shared popup as a native dialog. */
(function () {
  const popup = document.querySelector('[data-external-disclaimer]');
  if (!popup) return;

  const continueLink = popup.querySelector('.btn');

  function confirmExternalLink(event) {
    if (event.type === 'auxclick' && event.button !== 1) return;
    const link = event.target.closest('a[href]');
    if (!link || popup.contains(link)) return;

    const url = new URL(link.href, document.baseURI);
    if (!/^https?:$/.test(url.protocol) || !/(^|\.)beljanski\.(org|info)$/.test(url.hostname)) return;

    event.preventDefault();
    continueLink.href = link.href;
    if (!popup.open) popup.showModal();
  }

  // Delegation covers links added by the theme editor and clicks on nested icons.
  document.addEventListener('click', confirmExternalLink);
  document.addEventListener('auxclick', confirmExternalLink);
  popup.querySelector('[data-external-disclaimer-close]').addEventListener('click', () => popup.close());
  continueLink.addEventListener('click', () => popup.close());
  popup.addEventListener('click', event => {
    if (event.target !== popup) return;
    const bounds = popup.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) popup.close();
  });
})();
